import { Navigate } from 'react-router-dom';

/** Old merchant bookmarks enter the migrated fixed storefront editor. */
export function LegacyStorefrontRedirect(): React.JSX.Element {
  return <Navigate to="/storefront" replace />;
}
